var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("License")]),_c('div',[_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('content'))}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }